module.exports = __webpack_public_path__ + "img/20180815_151538_162.e39aa305.jpg";